import constants from "../../constants";
import { useContext, useEffect } from "react";
import AlertContext from "../../context/AlertContext";
import { LibraryContext } from "../../context/LibraryContext";
import CreateSchemaTableHooks from "../CreateSchemaTableHooks";

export default function GetQuestionDetailHooks() {
  const Alert = useContext(AlertContext);
  const LibraryCxt = useContext(LibraryContext);

  const CreateSchemaTableHks = CreateSchemaTableHooks();

  useEffect(() => {
    
    // if (Object.keys(Alert.testDetail).length <= 2) {
      Alert.setTestDetail(
        Alert.isqueReport && Alert.tableShowStatus === constants.libTypeIds.SQL
          ? {
              qnId: Alert.selectque?.qnId,
              name: Alert.selectque?.name,
              marks: Alert.selectque?.marks,
              solution: Alert.selectque?.solution,
              dbSchema: Alert.selectque?.dbSchema,
              datatype: Alert.selectque?.datatype,
              maxtime: Alert.selectque?.timelimit,
              boilerPlate: Alert.selectque?.solution,
              description: Alert.selectque?.description,
              complexityid: JSON.parse(Alert.selectque?.topics)[0].compid,
              ansexp: Alert.selectque?.ansexp || Alert.selectque?.ans_explain,
              schema: CreateSchemaTableHks.parseCreateTable(
                Alert.selectque?.dbSchema
              ),
              language: [
                {
                  value: 1,
                  label: "SQL",
                },
              ],
              selectedLanguage: {
                value: 1,
                label: "SQL",
              },
              saqlaqAnswer:
                Alert.selectque?.isAnswer?.length > 0
                  ? Alert.selectque?.isAnswer.map((output) => output.optionText)
                  : [""],
            }
          : {
              language: [
                {
                  value: 1,
                  label: "SQL",
                },
              ],
              selectedLanguage: {
                value: 1,
                label: "SQL",
              },
            }
      );
    // }

    LibraryCxt.setUserInp(
      Alert.isqueReport &&
        Alert.tableShowStatus === constants.libTypeIds.CODING_CHALLENGE
        ? {
            name: Alert.selectque?.qdata?.name,
            marks: Alert.selectque?.qdata?.marks,
            topicData: Alert.selectque?.topicData,
            ansexp: Alert.selectque?.qdata?.ansexp,
            inputvars: Alert.selectque?.cc?.inputvars,
            datatypes: Alert.selectque?.cc?.datatypes,
            evalrules: Alert.selectque?.cc?.evalrules,
            maxtime: Alert.selectque?.qdata?.timelimit,
            returntype: Alert.selectque?.cc?.returntype,
            questionid: Alert.selectque?.qdata?.questionid,
            description: Alert.selectque?.qdata?.description,
            autoevaluate: Alert.selectque?.qdata?.autoevaluate,
            functionname: Alert.selectque?.cc?.functionname || "",
            exampleinput: Alert.selectque?.io
              ?.filter((data) => data.isexample)
              .map((filteredinput) => filteredinput.input)
              .join("\r\n"),
            exampleoutput: Alert.selectque?.io
              ?.filter((data) => data.isexample)
              .map((filteredoutput) => filteredoutput.output)
              .join("\r\n"),
            secData:Alert.selectque?.secData
          }
        : Alert.tableShowStatus === constants.libTypeIds.CODING_CHALLENGE
        ? { autoevaluate: 1 }
        : Alert.isqueReport
        ? {
            qnId: Alert.selectque?.qnId,
            name: Alert.selectque?.name,
            marks: Alert.selectque?.marks,
            datatype: Alert.selectque?.datatype,
            maxtime: Alert.selectque?.timelimit,
            description: Alert.selectque?.description,
            ansexp: Alert.selectque?.ansexp || Alert.selectque?.ans_explain,
            saqlaqAnswer:
              Alert.selectque?.isAnswer?.length > 0
                ? Alert.selectque?.isAnswer.map((output) => output.optionText)
                : [""],
          }
        : { saqlaqAnswer: [""] }
    );
  }, [Alert.selectque]);
}
